"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedProductSearchContainerComponent = AdvancedProductSearchContainerComponent;
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const React = __importStar(require("react"));
const Actions = __importStar(require("./actions"));
const action_buttons_row_component_1 = require("./components/action-buttons-row-component");
const form_fields_component_1 = require("./components/form-fields-component");
const container_1 = require("./search-results/container");
function AdvancedProductSearchContainerComponent(props) {
    return (React.createElement(Elements.FlexContainerStack, null,
        React.createElement(form_fields_component_1.FormFieldsComponent, { fields: [
                Object.assign(Object.assign({ label: "Product id", placeholder: "E.g. MXNCHF", details: "Required" }, props.fields.productId), { onChange: (value) => props.dispatch(Actions.setUi("productId", value)) }),
                Object.assign(Object.assign({ label: "Product property filter", placeholder: "E.g. size=1410~1818&circuits=1,3,4", details: "Optional" }, props.fields.productPropertyFilter), { onChange: (value) => props.dispatch(Actions.setUi("productPropertyFilter", value)) }),
                Object.assign(Object.assign({ label: "Operating case results filter", placeholder: "E.g. _AverageFaceVelocity>1:MeterPerSecond", details: "Optional" }, props.fields.operatingCaseResultsPropertyFilter), { onChange: (value) => props.dispatch(Actions.setUi("operatingCaseResultsPropertyFilter", value)) }),
                Object.assign(Object.assign({ label: "Properties", placeholder: "E.g. fluid,tuberows", details: "Optional. Comma-separated properties to include as columns in search results." }, props.fields.properties), { onChange: (value) => props.dispatch(Actions.setUi("properties", value)) }),
                Object.assign(Object.assign({ label: "Result Properties", placeholder: "E.g. _AverageFaceVelocity,_Efficiency", details: "Optional. Comma-separated properties to include as columns in search results." }, props.fields.resultProperties), { onChange: (value) => props.dispatch(Actions.setUi("resultProperties", value)) })
            ] }),
        React.createElement("div", { style: { display: "flex", alignItems: "center" } },
            React.createElement("p", { style: { margin: "0 8px" } }, "From: "),
            React.createElement("input", { type: "date", onChange: (e) => props.dispatch(Actions.setUi("fromDate", e.target.value)), value: props.fields.fromDate }),
            React.createElement("p", { style: { margin: "0 8px" } }, "To: "),
            React.createElement("input", { type: "date", onChange: (e) => props.dispatch(Actions.setUi("toDate", e.target.value)), value: props.fields.toDate })),
        React.createElement(action_buttons_row_component_1.ActionButtonsRowComponent, { center: true },
            React.createElement(Elements.StandardButton, { onClick: () => {
                    props.dispatch(Actions.search());
                }, disabled: !props.allFieldsValid }, "Search products"),
            React.createElement(Elements.StandardButton, { onClick: () => {
                    props.dispatch(Actions.clear());
                }, disabled: !props.showResults }, "Clear")),
        props.showResults ? (React.createElement(container_1.SearchResultsContainer, { searchOptions: props.searchOptions })) : undefined,
        React.createElement("br", null)));
}
//# sourceMappingURL=container-component.js.map